import React from 'react';
import { Grid, Box, Skeleton } from '@mui/material';
import { useResize } from 'hooks/common';

type DashboardTopSkeletonProps = {
  cardCount?: number; // Number of skeleton cards to display
};

const DashboardTopSkeleton: React.FC<DashboardTopSkeletonProps> = ({
  cardCount = 3,
}) => {
  const { isMobile } = useResize();

  return (
    <Grid item container gap={2}>
      <Grid
        container
        alignItems='center'
        position='relative'
        marginTop={isMobile ? '160px' : 'auto'}
      >
        <Box
          display='flex'
          gap={0.5}
          justifyContent='center'
          paddingLeft={2}
          flexDirection='column'
        >
          <Box display='flex' gap={0.5}>
            <Skeleton variant='text' width='190px' height='60px' />
          </Box>
          <Skeleton variant='text' width='220px' height='40px' />
        </Box>
      </Grid>

      <Grid container spacing={2} justifyContent='center' paddingLeft={2}>
        {Array.from({ length: cardCount }).map((_, index) => (
          <Grid item key={index} xs={12} sm={6} md={4} lg={4}>
            <Grid
              container
              direction='column'
              justifyContent='space-between'
              sx={{
                borderRadius: '12px',
                transition: 'transform 0.1s',
                width: '100%',
                aspectRatio: '2.15 / 1',
                minHeight: '150px',
                border: '1px solid #EEEEEE',
                padding: 2,
                bgcolor: 'white',
              }}
            >
              <Box display='flex' flexDirection='column'>
                <Skeleton variant='text' height='30px' />
                <Skeleton variant='text' height='30px' />
                <Skeleton variant='text' height='30px' />
              </Box>
              <Box
                display='flex'
                flexDirection='column'
                alignItems='flex-start'
                paddingLeft='10px'
                paddingBottom='10px'
              >
                <Skeleton
                  variant='rectangular'
                  width='25%'
                  height='40px'
                  sx={{ borderRadius: '10px' }}
                />
              </Box>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default DashboardTopSkeleton;
